import React, { useState, useRef, useEffect, useCallback } from "react";
import throttle from "lodash/throttle";

// component
import LogoOrbit from "../LogoOrbit";
import Container from "../Container";
import MenuItems from "../MenuItems";
import MenuMobile from "./MenuMobile";
import { IconMobileOrbit, CloseMenuIcon } from "@edricphan2022/uikit";
import { IconButton } from "@edricphan2022/uikit";
// styled
import {
  HeaderBox,
  HeaderLeft,
  HeaderRight,
  Wrapper,
  FixedContainer,
  BoxHeaderMobile,
} from "./style";
import { Flex, Box } from "@edricphan2022/uikit";
import { Text } from "@edricphan2022/uikit";

// responsive
import { useMatchBreakpoints } from "@edricphan2022/uikit";

//in folder
import { menuConfig } from "./config";
const HeaderOrbit: React.FC = () => {
  // responsive
  const { isTablet } = useMatchBreakpoints();
  const [isMenuMobile, setIsMenuMobile] = useState<boolean>(false);

  const [showMenu, setShowMenu] = useState(true);
  const [changeBackground, setChangeBackground] = useState(false);
  const refPrevOffset = useRef(window.pageYOffset);
  useEffect(() => {
    const handleScroll = () => {
      const currentOffset = window.pageYOffset;
      const isBottomOfPage =
        window.document.body.clientHeight ===
        currentOffset + window.innerHeight;
      const isTopOfPage = currentOffset === 0;
      // Always show the menu when user reach the top
      if (isTopOfPage) {
        setShowMenu(true);
        setChangeBackground(false);
      }
      // Avoid triggering anything at the bottom because of layout shift
      else if (!isBottomOfPage) {
        if (currentOffset < refPrevOffset.current) {
          // Has scroll up
          setShowMenu(true);
          setChangeBackground(true);
        } else {
          // Has scroll down
          setShowMenu(false);
          setChangeBackground(true);
        }
      }
      refPrevOffset.current = currentOffset;
    };
    const throttledHandleScroll = throttle(handleScroll, 200);

    window.addEventListener("scroll", throttledHandleScroll);
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
    };
  }, []);
  const handleMenuMobile = useCallback(() => {
    if (isTablet) {
      setIsMenuMobile((prevMenu) => !prevMenu);
    } else {
      setIsMenuMobile(false);
    }
  }, [isTablet]);

  return (
    <Wrapper as="header">
      <FixedContainer
        showMenu={showMenu}
        height={118}
        changeBackground={changeBackground}
      >
        <Container>
          <HeaderBox as="nav">
            <HeaderLeft>
              <LogoOrbit href="/" />
              {!isTablet && (
                <MenuItems
                  activeItem="Home"
                  activeSubItem="Home"
                  items={menuConfig}
                  ml={["0", "0", "0", "24px"]}
                />
              )}
            </HeaderLeft>
            <HeaderRight>
              <Flex>
                <IconButton
                  variant="tertiary"
                  startIcon={
                    <IconMobileOrbit width="27px" mr="16.5px" mt="6px" />
                  }
                  onClick={handleMenuMobile}
                />
                <Box height="30px" width="1px" background="#333333" />
                <Text ml="16.5px" fontFamily="ManropeMedium">
                  EN
                </Text>
              </Flex>
            </HeaderRight>
          </HeaderBox>
        </Container>
      </FixedContainer>
      {isTablet && (
        <BoxHeaderMobile isMenuMobile={isMenuMobile}>
          <Box>
            <MenuMobile
              handleMenuMobile={handleMenuMobile}
            />
          </Box>
        </BoxHeaderMobile>
      )}
    </Wrapper>
  );
};

export default HeaderOrbit;
